import React, { useState, useEffect, useRef } from 'react';
import { MenuForm } from '../Menu.js';
import { SecurityElement } from '../elements/security_element.js';
import "../../css/main.css"
import { YearsElement } from '../elements/years_element.js';
import { VisitListElement } from '../elements/visit_list_element.js';
import { useAPICall } from '../../hooks/useAPICall.js';
import { useLocation, useNavigate } from 'react-router-dom';
import { PageMenuElement } from '../elements/page_menu.js';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

export function AdminVisitsForm() {
  const location = useLocation();
  const navigate = useNavigate();
  const [yearName, setYearName] = useState('');
  const [pageData, setPageData] = useState();

  const [visitData, setVisitData] = useState([]);
  const [yearsData, setYearsData] = useState([]);

  const [memberData, setMemberData] = useState([]);
  const [visitDate, setVisitDate] = useState(new Date());

  const { MakeCall } = useAPICall();

  let first_render = useRef(true);
  
  const handleDataFetch = (data) => {
    setPageData(data);
    if (yearName.length === 0) {
      setYearName(data.components['years'][0]);
    }
    setVisitData(data.components['visits']);
    setYearsData(data.components['years']);
  }

  if (first_render.current === true) {
    setMemberData(location.state.memberData);

    MakeCall('admin/adminmembervisitpage', "{ \"token\" : \"" + sessionStorage.getItem("Token") + "\", \"yearname\" : \"" + yearName + "\", \"memberid\" : \"" + location.state.memberData.idpeveril_member + "\"}", handleDataFetch);

    first_render.current = false;
  }

  useEffect(() => {

  });
  function handleNav(destination, state) {
    navigate(destination, state);
  }
  function handleYearClicked(yearName) {
    setYearName(yearName);
    MakeCall('admin/adminmembervisitpage', "{ \"token\" : \"" + sessionStorage.getItem("Token") + "\", \"yearname\" : \"" + yearName + "\", \"memberid\" : \"" + memberData.idpeveril_member + "\"}", handleDataFetch, true);
  }

  function onPageMenuClick(onclickname) {
    switch (onclickname) {
        case 'goback':
            handleNav("/ViewMember", { state: { memberID: memberData.idpeveril_member } });
            break;
        case 'addvisit':
          document.getElementById("addvisitform").style.display ="block";
              break;       
        default:
          break;
  
    }
  }

  function handleSaveVisit(data)
  {
      document.getElementById("addvisitform").style.display ="none";
      MakeCall('admin/adminmembervisitpage', "{ \"token\" : \"" + sessionStorage.getItem("Token") + "\", \"yearname\" : \"" + yearName + "\", \"memberid\" : \"" + location.state.memberData.idpeveril_member + "\"}", handleDataFetch, true);

  }
  function handleAddVisit() {
    let visitdescription = document.getElementById('visitdescription').value;
    
     MakeCall('admin/addvisit', "{ \"token\" : \"" + sessionStorage.getItem("Token") + "\"," +
             "\"memberid\":\"" + memberData.idpeveril_member + "\", "+
             "\"visitdate\":\"" + visitDate.toLocaleDateString('en-GB',  {year: 'numeric', month: 'long', day: 'numeric'}) + "\", " +
             "\"visitdescription\":\"" + visitdescription + "\"}", handleSaveVisit, true);
}
  function AddVisitForm() {
    
        return (
            <div className='popup_form' id="addvisitform">
                <h1>Add a visit for this member</h1>                
                <div className='formrow' style={{"paddingBottom":"1em"}}>
                    <div className='formlabel' style={{ "width": "30%" }}>
                        Visit Date
                    </div>
                    <div className='formvalue'>
                        {<DatePicker
                            showIcon
                            selected={visitDate}
                            onChange={(date) => setVisitDate(date)}
                            name="startDate"
                            dateFormat="dd/MM/yyyy" />}
                    </div>
                </div>
                <div className='formrow' style={{"paddingBottom":"1em"}}>
                    <div className='formlabel' style={{ "width": "30%" }}>
                        Notes
                    </div>
                    <div className='formvalue'>       
                    <input id='visitdescription' type="text" className='logininput'/>               
                    </div>
                </div>
                <div className='formrowcentered'>
                    <div className='formlabel'>
                        <input type='button' className='prcbtn' value='Add Visit' onClick={handleAddVisit}/>
                    </div>
                    <div className='formlabel'>
                        <input type='button' className='prcbtn' value='Cancel' onClick={()=>{document.getElementById("addvisitform").style.display ="none"}}/>
                    </div>
                </div>
            </div>);    
  }

  return (
    <div>
      {SecurityElement(pageData)}
      {MenuForm()}
      {AddVisitForm()}
      <div className="contentdiv">
      {PageMenuElement("View Visits", [{ "name": "Back", "onclick": "goback" },
                { "name": "Add Visit", "onclick": "addvisit" }], onPageMenuClick)}
       

        <div className='formbox'>
          <div className='formtitle'>Details</div>

          <div className='formrow'>
            <div className='formlabel'>Number</div>
            <div className='formvalue'>{memberData.membership_number}</div>
          </div>
          <div className='formrow'>
            <div className='formlabel'>Type</div>
            <div className='formvalue'>{memberData.peveril_membership_type}</div>
          </div>
          <div className='formrow'>
            <div className='formlabel'>Forename</div>
            <div className='formvalue'>{memberData.forename}</div>
          </div>
          <div className='formrow'>
            <div className='formlabel'>Surname</div>
            <div className='formvalue'>{memberData.surname}</div>
          </div>
        </div>


        {YearsElement(yearsData, handleYearClicked)}
        {VisitListElement(visitData, yearName)}
      </div>
    </div>




  );
}
